import styled from "styled-components";

export const StyledContainer = styled("div")<{
  border?: boolean;
}>`
  position: relative;
  width: 100%;
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 80px;
  border-top: ${(p) => (p.border ? "1px solid var(--border-color)" : "")};
  z-index: 1;

  @media only screen and (max-width: 1440px) {
    max-width: 1200px;
    padding: 0 60px;
  }

  @media only screen and (max-width: 1024px) {
    max-width: 100%;
    padding: 0 40px;
  }

  @media only screen and (max-width: 768px) {
    padding: 0 24px;
  }

  @media only screen and (max-width: 480px) {
    padding: 0 20px;
  }
`;
